import { CarouselInfoCardData, CarouselInfoCardPointerPosition } from '../types';
import { v4 as uuidv4 } from 'uuid';

export const carouselMockData: CarouselInfoCardData[] = [
  {
    id: uuidv4(),
    pointerPosition: CarouselInfoCardPointerPosition.TOP_BORDER_LEFT_SIDE,
    headerTitle: 'Header title goes here 1',
    bodyTitle: 'Body title goes here 1',
    imageSrc: 'app/webcomponents/assets/images/trial/xdr/xdrHeader.jpg',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    primaryButtonText: 'Primary button',
    secondaryButtonText: 'Secondary button',
  },
  {
    id: uuidv4(),
    pointerPosition: CarouselInfoCardPointerPosition.RIGHT_BORDER_UPPER_SIDE,
    headerTitle: 'Header title goes here 2',
    imageSrc: 'app/webcomponents/assets/images/trial/msp/productsHome/mdrHome.jpeg',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    primaryButtonText: 'Primary button',
    secondaryButtonText: 'Secondary button',
  },
  {
    id: uuidv4(),
    pointerPosition: CarouselInfoCardPointerPosition.BOTTOM_BORDER_RIGHT_SIDE,
    headerTitle: 'Header title goes here 3',
    imageSrc: 'app/webcomponents/assets/images/trial/msp/productsHome/edrHome.jpeg',
    bodyTitle: 'Body title goes here 3',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    primaryButtonText: 'Primary button',
  },
  {
    id: uuidv4(),
    pointerPosition: CarouselInfoCardPointerPosition.LEFT_BORDER_LOWER_SIDE,
    bodyTitle: 'Body title goes here 4',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
